import ImgWrapper from "components/global/ImgWrapper";
import { Link } from "react-router-dom";
import Spacer from "components/global/Spacer";
import { connect } from "react-redux";
import { setLoggedIn } from "api";
import styled from "styled-components";
import { useClickOutside } from "webrix/hooks";

const Wrapper = styled.div`
  width: 27rem;
  box-shadow: 0px 0px 5px 0px #0000000d;
  background-color: #ffffff;
  z-index: 5;
  position: absolute;
  top: 4.8rem;
  right: 0;
  padding: 2.4rem 0;

  a {
    color: inherit;
    text-decoration: none;

    &:focus {
      outline: none;
    }
  }

  .header {
    display: grid;
    grid-template-columns: 4rem auto;
    grid-gap: 1.2rem;
    padding: 0 2.4rem;
  }

  .content {
    border-top: 1px solid #f2f3f7;
    border-bottom: 1px solid #f2f3f7;
    padding: 1.2rem 0;
    display: grid;
    grid-template-columns: 1fr;

    .icon {
      height: 2rem;
    }
  }

  .affiliate {
    border-bottom: 1px solid #f2f3f7;
  }

  .item {
    padding: 1.2rem 2.4rem;

    &:hover {
      background-color: var(--background);
    }
  }

  .truncate {
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const Avatar = styled(ImgWrapper)`
  .initials {
    color: #ffffff;
    line-height: 18px;
  }
`;

const userIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18C7.87827 18 5.84344 17.1571 4.34315 15.6569C2.84285 14.1566 2 12.1217 2 10C2 7.87827 2.84285 5.84344 4.34315 4.34315C5.84344 2.84285 7.87827 2 10 2C12.1217 2 14.1566 2.84285 15.6569 4.34315C17.1571 5.84344 18 7.87827 18 10ZM12 7C12 7.53043 11.7893 8.03914 11.4142 8.41421C11.0391 8.78929 10.5304 9 10 9C9.46957 9 8.96086 8.78929 8.58579 8.41421C8.21071 8.03914 8 7.53043 8 7C8 6.46957 8.21071 5.96086 8.58579 5.58579C8.96086 5.21071 9.46957 5 10 5C10.5304 5 11.0391 5.21071 11.4142 5.58579C11.7893 5.96086 12 6.46957 12 7ZM10 11C9.0426 10.9998 8.10528 11.2745 7.29942 11.7914C6.49356 12.3083 5.85304 13.0457 5.454 13.916C6.01668 14.5706 6.71427 15.0958 7.49894 15.4555C8.28362 15.8152 9.13681 16.0009 10 16C10.8632 16.0009 11.7164 15.8152 12.5011 15.4555C13.2857 15.0958 13.9833 14.5706 14.546 13.916C14.147 13.0457 13.5064 12.3083 12.7006 11.7914C11.8947 11.2745 10.9574 10.9998 10 11Z"
      fill="#545454"
    />
  </svg>
);

const settingsIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4897 3.17C11.1097 1.61 8.88975 1.61 8.50975 3.17C8.45302 3.40442 8.34174 3.62213 8.18497 3.80541C8.02821 3.9887 7.83038 4.13238 7.60759 4.22477C7.38481 4.31716 7.14336 4.35564 6.90289 4.33709C6.66242 4.31854 6.42973 4.24347 6.22375 4.118C4.85175 3.282 3.28175 4.852 4.11775 6.224C4.65775 7.11 4.17875 8.266 3.17075 8.511C1.60975 8.89 1.60975 11.111 3.17075 11.489C3.40523 11.5458 3.62298 11.6572 3.80626 11.8141C3.98955 11.971 4.13319 12.1689 4.22549 12.3918C4.31779 12.6147 4.35614 12.8563 4.33742 13.0968C4.3187 13.3373 4.24343 13.5701 4.11775 13.776C3.28175 15.148 4.85175 16.718 6.22375 15.882C6.42969 15.7563 6.6624 15.6811 6.90293 15.6623C7.14347 15.6436 7.38502 15.682 7.60793 15.7743C7.83084 15.8666 8.02879 16.0102 8.18568 16.1935C8.34256 16.3768 8.45394 16.5945 8.51075 16.829C8.88975 18.39 11.1108 18.39 11.4888 16.829C11.5457 16.5946 11.6572 16.377 11.8142 16.1939C11.9711 16.0107 12.169 15.8672 12.3918 15.7749C12.6147 15.6826 12.8561 15.6442 13.0966 15.6628C13.3371 15.6815 13.5698 15.7565 13.7758 15.882C15.1477 16.718 16.7178 15.148 15.8818 13.776C15.7563 13.57 15.6812 13.3373 15.6626 13.0969C15.644 12.8564 15.6824 12.6149 15.7747 12.3921C15.8669 12.1692 16.0105 11.9713 16.1936 11.8144C16.3768 11.6575 16.5944 11.546 16.8288 11.489C18.3898 11.11 18.3898 8.889 16.8288 8.511C16.5943 8.45419 16.3765 8.34281 16.1932 8.18593C16.01 8.02904 15.8663 7.83109 15.774 7.60818C15.6817 7.38527 15.6434 7.14372 15.6621 6.90318C15.6808 6.66265 15.7561 6.42994 15.8818 6.224C16.7178 4.852 15.1477 3.282 13.7758 4.118C13.5698 4.24368 13.3371 4.31895 13.0966 4.33767C12.856 4.35639 12.6145 4.31804 12.3916 4.22574C12.1687 4.13344 11.9707 3.9898 11.8138 3.80651C11.6569 3.62323 11.5456 3.40548 11.4888 3.171L11.4897 3.17ZM9.99975 13C10.7954 13 11.5585 12.6839 12.1211 12.1213C12.6837 11.5587 12.9998 10.7956 12.9998 10C12.9998 9.20435 12.6837 8.44129 12.1211 7.87868C11.5585 7.31607 10.7954 7 9.99975 7C9.2041 7 8.44104 7.31607 7.87843 7.87868C7.31582 8.44129 6.99975 9.20435 6.99975 10C6.99975 10.7956 7.31582 11.5587 7.87843 12.1213C8.44104 12.6839 9.2041 13 9.99975 13Z"
      fill="#545454"
    />
  </svg>
);

const cashIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V10C2 10.5304 2.21071 11.0391 2.58579 11.4142C2.96086 11.7893 3.46957 12 4 12V6H14C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H4ZM6 10C6 9.46957 6.21071 8.96086 6.58579 8.58579C6.96086 8.21071 7.46957 8 8 8H16C16.5304 8 17.0391 8.21071 17.4142 8.58579C17.7893 8.96086 18 9.46957 18 10V14C18 14.5304 17.7893 15.0391 17.4142 15.4142C17.0391 15.7893 16.5304 16 16 16H8C7.46957 16 6.96086 15.7893 6.58579 15.4142C6.21071 15.0391 6 14.5304 6 14V10ZM12 14C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12C14 11.4696 13.7893 10.9609 13.4142 10.5858C13.0391 10.2107 12.5304 10 12 10C11.4696 10 10.9609 10.2107 10.5858 10.5858C10.2107 10.9609 10 11.4696 10 12C10 12.5304 10.2107 13.0391 10.5858 13.4142C10.9609 13.7893 11.4696 14 12 14Z"
      fill="#545454"
    />
  </svg>
);

const cardIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
      fill="#545454"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
      fill="#545454"
    />
  </svg>
);

// const refreshIcon = (
//   <svg
//     width="20"
//     height="20"
//     viewBox="0 0 20 20"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       fillRule="evenodd"
//       clipRule="evenodd"
//       d="M4 2C4.26522 2 4.51957 2.10536 4.70711 2.29289C4.89464 2.48043 5 2.73478 5 3V5.101C5.83204 4.25227 6.86643 3.62931 8.00574 3.29078C9.14506 2.95226 10.3518 2.90932 11.5123 3.16601C12.6728 3.42269 13.7488 3.97056 14.6391 4.758C15.5294 5.54544 16.2045 6.54654 16.601 7.667C16.6491 7.79176 16.6717 7.92489 16.6674 8.05854C16.6632 8.19218 16.6322 8.32361 16.5763 8.44506C16.5203 8.56651 16.4406 8.67551 16.3418 8.76561C16.243 8.85571 16.1272 8.92508 16.0011 8.96963C15.875 9.01417 15.7413 9.03298 15.6078 9.02494C15.4744 9.0169 15.3439 8.98217 15.224 8.92282C15.1042 8.86346 14.9975 8.78068 14.9103 8.67937C14.823 8.57806 14.7569 8.46029 14.716 8.333C14.4141 7.47982 13.8865 6.72451 13.1892 6.14758C12.4919 5.57064 11.6512 5.19369 10.7566 5.05688C9.86195 4.92008 8.94698 5.02855 8.10916 5.37074C7.27133 5.71293 6.54204 6.27602 5.999 7H9C9.26522 7 9.51957 7.10536 9.70711 7.29289C9.89464 7.48043 10 7.73478 10 8C10 8.26522 9.89464 8.51957 9.70711 8.70711C9.51957 8.89464 9.26522 9 9 9H4C3.73478 9 3.48043 8.89464 3.29289 8.70711C3.10536 8.51957 3 8.26522 3 8V3C3 2.73478 3.10536 2.48043 3.29289 2.29289C3.48043 2.10536 3.73478 2 4 2ZM4.008 11.057C4.13184 11.0133 4.26308 10.9943 4.39422 11.0013C4.52537 11.0083 4.65386 11.0411 4.77235 11.0977C4.89084 11.1544 4.99701 11.2338 5.0848 11.3315C5.17259 11.4291 5.24028 11.5432 5.284 11.667C5.58586 12.5202 6.11355 13.2755 6.81082 13.8524C7.50809 14.4294 8.34883 14.8063 9.24344 14.9431C10.138 15.0799 11.053 14.9714 11.8908 14.6293C12.7287 14.2871 13.458 13.724 14.001 13H11C10.7348 13 10.4804 12.8946 10.2929 12.7071C10.1054 12.5196 10 12.2652 10 12C10 11.7348 10.1054 11.4804 10.2929 11.2929C10.4804 11.1054 10.7348 11 11 11H16C16.2652 11 16.5196 11.1054 16.7071 11.2929C16.8946 11.4804 17 11.7348 17 12V17C17 17.2652 16.8946 17.5196 16.7071 17.7071C16.5196 17.8946 16.2652 18 16 18C15.7348 18 15.4804 17.8946 15.2929 17.7071C15.1054 17.5196 15 17.2652 15 17V14.899C14.168 15.7477 13.1336 16.3707 11.9943 16.7092C10.8549 17.0477 9.64821 17.0907 8.48772 16.834C7.32723 16.5773 6.25117 16.0294 5.36091 15.242C4.47065 14.4546 3.79548 13.4535 3.399 12.333C3.35526 12.2092 3.33634 12.0779 3.34333 11.9468C3.35031 11.8156 3.38306 11.6871 3.43971 11.5687C3.49635 11.4502 3.57578 11.344 3.67346 11.2562C3.77114 11.1684 3.88516 11.1007 4.009 11.057H4.008Z"
//       fill="#545454"
//     />
//   </svg>
// );
const AffiliateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 5.00003C5 3.34318 6.34315 2.00003 8 2.00003C8.76836 2.00003 9.46924 2.28888 10 2.76393C10.5308 2.28888 11.2316 2.00003 12 2.00003C13.6569 2.00003 15 3.34318 15 5.00003C15 5.35067 14.9398 5.68725 14.8293 6.00003H16C17.1046 6.00003 18 6.89546 18 8.00003C18 9.1046 17.1046 10 16 10H11V9.00003C11 8.44775 10.5523 8.00003 10 8.00003C9.44772 8.00003 9 8.44775 9 9.00003V10H4C2.89543 10 2 9.1046 2 8.00003C2 6.89546 2.89543 6.00003 4 6.00003H5.17071C5.06015 5.68725 5 5.35067 5 5.00003ZM9 6.00003V5.00003C9 4.44775 8.55228 4.00003 8 4.00003C7.44772 4.00003 7 4.44775 7 5.00003C7 5.55232 7.44772 6.00003 8 6.00003H9ZM12 6.00003C12.5523 6.00003 13 5.55232 13 5.00003C13 4.44775 12.5523 4.00003 12 4.00003C11.4477 4.00003 11 4.44775 11 5.00003V6.00003H12Z"
      fill="#545454"
    />
    <path d="M9 11H3V16C3 17.1046 3.89543 18 5 18H9V11Z" fill="#545454" />
    <path d="M11 18H15C16.1046 18 17 17.1046 17 16V11H11V18Z" fill="#545454" />
  </svg>
);

const exitIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3C3.26522 3 3.51957 3.10536 3.70711 3.29289C3.89464 3.48043 4 3.73478 4 4V16C4 16.2652 3.89464 16.5196 3.70711 16.7071C3.51957 16.8946 3.26522 17 3 17C2.73478 17 2.48043 16.8946 2.29289 16.7071C2.10536 16.5196 2 16.2652 2 16V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM10.707 6.293C10.8945 6.48053 10.9998 6.73484 10.9998 7C10.9998 7.26516 10.8945 7.51947 10.707 7.707L9.414 9H17C17.2652 9 17.5196 9.10536 17.7071 9.29289C17.8946 9.48043 18 9.73478 18 10C18 10.2652 17.8946 10.5196 17.7071 10.7071C17.5196 10.8946 17.2652 11 17 11H9.414L10.707 12.293C10.8892 12.4816 10.99 12.7342 10.9877 12.9964C10.9854 13.2586 10.8802 13.5094 10.6948 13.6948C10.5094 13.8802 10.2586 13.9854 9.9964 13.9877C9.7342 13.99 9.4816 13.8892 9.293 13.707L6.293 10.707C6.10553 10.5195 6.00021 10.2652 6.00021 10C6.00021 9.73484 6.10553 9.48053 6.293 9.293L9.293 6.293C9.48053 6.10553 9.73484 6.00021 10 6.00021C10.2652 6.00021 10.5195 6.10553 10.707 6.293Z"
      fill="#FD0403"
    />
  </svg>
);

const UserOptions = ({ user, setShowUserOptions, member }) => {
  const handleOnMouseDownCapture = useClickOutside(() => {
    setShowUserOptions(false);
  });

  const hasAccess = member?.user_role_on_account === 1;
  return (
    <Wrapper
      onMouseDownCapture={handleOnMouseDownCapture}
      className="settings-tour"
    >
      <div className="header">
        <Avatar as="button" bg="var(--primary)" size={4}>
          {user?.image ? (
            <img src={user.image} alt="AVI" />
          ) : (
            <h5 className="initials textCenter textUppercase">{`${user?.full_name
              ?.split(" ")[0]
              .charAt(0)}${user?.full_name?.split(" ")[1].charAt(0)}`}</h5>
          )}
        </Avatar>
        <div>
          <h6 className="body-2 textCapitalize colorGrey1 truncate">
            {user?.full_name}
          </h6>
          <p className="textDescription colorBodyText truncate">
            {user?.email}
          </p>
        </div>
      </div>
      <Spacer y={1.2} />
      <div className="content">
        <Link
          to="/dashboard/profile"
          className="flexRow alignCenter item"
          onClick={() => setShowUserOptions(false)}
        >
          {userIcon}
          <Spacer x={1.2} />
          <span className="l3 colorBodytext">User profile</span>
        </Link>
        {hasAccess && (
          <>
            <Link
              to="/dashboard/workspace-settings"
              className="flexRow alignCenter item"
              onClick={() => setShowUserOptions(false)}
            >
              {settingsIcon}
              <Spacer x={1.2} />
              <span className="l3 colorBodytext">Workspace settings</span>
            </Link>

            <Link
              to="/dashboard/plans"
              className="flexRow alignCenter item"
              onClick={() => setShowUserOptions(false)}
            >
              {cashIcon}
              <Spacer x={1.2} />
              <span className="l3 colorBodytext">Plans</span>
            </Link>
            <Link
              to="/dashboard/billing"
              className="flexRow alignCenter item"
              onClick={() => setShowUserOptions(false)}
            >
              {cardIcon}
              <Spacer x={1.2} />
              <span className="l3 colorBodytext">Billing</span>
            </Link>
          </>
        )}
        {/* <button
          className="item flexRow alignCenter"
          onClick={() => {
            setShowUserOptions(false);
            document.querySelector("#switchUser").classList.add("show");
          }}
          disabled={true}
        >
          {refreshIcon}
          <Spacer x={1.2} />
          <span className="l3 colorBodytext">Switch users</span>
        </button> */}
      </div>
      <Link
        to="/dashboard/affiliate-program"
        className="flexRow alignCenter item affiliate"
        onClick={() => setShowUserOptions(false)}
      >
        {AffiliateIcon}
        <Spacer x={1.2} />
        <span className="l3 colorBodytext">Affiliate program</span>
      </Link>
      <Spacer y={1.2} />
      <button
        className="item flexRow alignCenter fullWidth"
        onClick={() => setLoggedIn(false)}
      >
        {exitIcon}
        <Spacer x={1.2} />
        <span className="sup text colorDanger">Logout</span>
      </button>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    member: state.member,
  };
};

export default connect(mapStateToProps)(UserOptions);
